import { Button, Flex } from 'antd'
import { useState } from 'react'
import { ActionStep, ApprovalStep } from 'src/pages/budget/budgetRequests/types'

type Props = {
  text: string
  color: 'green' | 'red' | 'volcano'
  id: number
  approvalSteps: ApprovalStep[]
  callback: (item: ActionStep) => Promise<void>
}

export const AvailableStepButtons = ({
  id,
  approvalSteps,
  text,
  color,
  callback,
}: Props) => {
  const [loadingId, setLoadingId] = useState<number | null>(null)
  const finalStep = approvalSteps.find((step) => step.isFinal)
  const nonFinalSteps = approvalSteps.filter(
    (step) => step.id !== finalStep?.id,
  )

  const maxLevelStep =
    nonFinalSteps.length > 0
      ? nonFinalSteps.reduce((max, step) =>
          step.level > max.level ? step : max,
        )
      : undefined

  const buttons = [finalStep, maxLevelStep].filter(
    (step): step is ApprovalStep => Boolean(step),
  )

  return (
    <Flex vertical gap={5} style={{ flex: 1 }}>
      {buttons.map((btn) => (
        <Button
          key={btn.id}
          size="large"
          variant="solid"
          onClick={async () => {
            setLoadingId(btn.id)
             try {
               await callback({
                 id,
                 stepId: btn.id,
                 teamName: btn.teamName,
                 isFinal: btn.isFinal ?? false,
               })
             } finally {
               setLoadingId(null)
             }
          }}
          color={color}
          loading={loadingId === btn.id}
        >
          {text}: {btn.teamName} {btn.isFinal && '(Финальный)'}
        </Button>
      ))}
    </Flex>
  )
}
